import React, { useEffect } from "react";
import { AlertTriangle, Trash2, Wrench, X } from "lucide-react";

const ICONS = { warning: AlertTriangle, trash: Trash2, wrench: Wrench };

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "primary", // "primary" | "danger"
  icon = "warning",
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onCancel?.(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onCancel]);

  if (!open) return null;
  const Icon = ICONS[icon] || AlertTriangle;
  const btn = confirmVariant === "danger" ? "btn-danger" : "btn-primary";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      onClick={onCancel}
      data-testid="confirm-dialog"
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="flex items-center gap-2">
            <Icon size={16} style={{ color: confirmVariant === "danger" ? "#C0362C" : "var(--accent-hover)" }} />
            <h3 className="font-display text-lg font-bold" data-testid="confirm-dialog-title">{title}</h3>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="btn-ghost !py-1 !px-1.5"
            aria-label="Close"
            data-testid="confirm-dialog-close"
          >
            <X size={14} />
          </button>
        </div>
        {description && (
          <p className="muted text-sm mb-5" data-testid="confirm-dialog-description">
            {description}
          </p>
        )}
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            className="btn-ghost text-xs"
            onClick={onCancel}
            data-testid="confirm-dialog-cancel"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`${btn} text-xs`}
            onClick={onConfirm}
            autoFocus
            data-testid="confirm-dialog-confirm"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
